export default "__VITE_ASSET__DkGljQaL__"